import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import OrgUserPage from './pages/OrgUserPage';
import SubuserPage from './pages/SubuserPage';
import DashboardPage from './pages/DashboardPage';
import CouponsPage from './pages/CouponsPage';
import TestPage from './pages/TestPage';
import PresentPage from './pages/PresentPage';
import RequireAuth from './auth/RequireAuth';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <RequireAuth allowedRoles={['admin']}>
                <AdminPage />
              </RequireAuth>
            }
          />
          <Route
            path="/org"
            element={
              <RequireAuth allowedRoles={['user']}>
                <OrgUserPage />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth allowedRoles={['user']}>
                <DashboardPage />
              </RequireAuth>
            }
          />
          <Route
            path="/coupons"
            element={
              <RequireAuth allowedRoles={['user']}>
                <CouponsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/test"
            element={
              <RequireAuth allowedRoles={['subuser']}>
                <TestPage />
              </RequireAuth>
            }
          />
          <Route
            path="/present"
            element={
              <RequireAuth allowedRoles={['user']}>
                <PresentPage />
              </RequireAuth>
            }
          />
          <Route
            path="/subuser"
            element={
              <RequireAuth allowedRoles={['subuser']}>
                <SubuserPage />
              </RequireAuth>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
